module.exports = "/components/components/customerReviewsComponent-8dd6b3.html";